import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/documentation/documentation/theme/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` PGP based registry signatures will be deprecated on `}<strong parentName="p">{`April 25th 2023`}</strong>{` in favour of `}<a parentName="p" {...{
          "href": "/about-registry-signatures"
        }}>{`ECDSA registry signatures`}</a>{`. This means no new packages will be signed with PGP keys from this date onwards and the `}<a parentName="p" {...{
          "href": "https://keybase.io/npmregistry"
        }}>{`public key hosted on Keybase`}</a>{` will expire.`}</p>
    </Note>
    <p>{`To increase confidence in the npm public registry, we add our `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Pretty_Good_Privacy"
      }}>{`PGP`}</a>{` signature to package metadata and publicize our public PGP key on `}<a parentName="p" {...{
        "href": "https://keybase.io"
      }}>{`Keybase`}</a>{`. Our Keybase account is "`}<a parentName="p" {...{
        "href": "https://keybase.io/npmregistry"
      }}>{`npmregistry`}</a>{`" and our public PGP key can be found at `}<a parentName="p" {...{
        "href": "https://keybase.io/npmregistry/pgp_keys.asc"
      }}>{`https://keybase.io/npmregistry/pgp_keys.asc`}</a></p>
    <p>{`You can use the package PGP signature and our public PGP key to verify that the same entity who published the key (npm) also signed the package you downloaded from the npm public registry. For more information, see "`}<a parentName="p" {...{
        "href": "verifying-the-pgp-signature-for-a-package-from-the-npm-public-registry"
      }}>{`Verifying the PGP signature of a package from the npm public registry`}</a>{`".`}</p>
    <h2>{`Tools we use`}</h2>
    <h3>{`openpgpjs`}</h3>
    <p>{`To generate PGP signatures, we use `}<a parentName="p" {...{
        "href": "https://github.com/openpgpjs/openpgpjs"
      }}>{`openpgpjs`}</a>{`, a pure JavaScript implementation of OpenPGP. To learn more about openpgpjs, see `}<a parentName="p" {...{
        "href": "https://openpgpjs.org/"
      }}>{`https://openpgpjs.org/`}</a>{`.`}</p>
    <h3>{`Keybase`}</h3>
    <p>{`We use Keybase to publicize our PGP key and give you confidence that the npm registry you install from is the same registry that signs packages.`}</p>
    <p>{`Keybase offers two advantages over the core OpenPGP experience that move us to recommend it to you:`}</p>
    <ul>
      <li parentName="ul">{`The Keybase application and CLI provide an excellent user experience for PGP, which can be intimidating for newcomers.`}</li>
      <li parentName="ul">{`Keybase manages and displays social proofs that the entity that controls a specific PGP key also controls accounts on social media and other places. These proofs help you determine whether you can trust an account.`}</li>
    </ul>
    <p>{`We’ve established proofs on Keybase that we control `}<a parentName="p" {...{
        "href": "https://twitter.com/npmjs"
      }}>{`@npmjs`}</a>{` on Twitter, the domain `}<a parentName="p" {...{
        "href": "https://npmjs.com"
      }}>{`npmjs.com`}</a>{`, and the domain `}<a parentName="p" {...{
        "href": "https://npmjs.org"
      }}>{`npmjs.org`}</a>{`. Verifying these proofs won’t tell you who owns those domains, but it does establish that the same entity controls them, and the PGP key advertised on Keybase.`}</p>
    <p>{`If you install Keybase and create an account, you can follow npmregistry yourself and obtain a local copy of the registry’s public key. For more information, and to verify the PGP signature of a specific package version from the npm public registry, see "`}<a parentName="p" {...{
        "href": "verifying-the-pgp-signature-for-a-package-from-the-npm-public-registry"
      }}>{`Verifying the PGP signature for a package from the npm public registry`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      